import { render, staticRenderFns } from "./ListadoPlazos.vue?vue&type=template&id=16b1be2d"
import script from "./ListadoPlazos.vue?vue&type=script&lang=js"
export * from "./ListadoPlazos.vue?vue&type=script&lang=js"
import style0 from "./ListadoPlazos.vue?vue&type=style&index=0&id=16b1be2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports